import { fieldValueTypes, IField } from '@pbl/pbl-react-core/lib/models/forms/types';
import { ITicketTab } from '@pbl/pbl-react-core/lib/models/ticket/types';
import DrawLogo from 'assets/img/Draw Ticket.svg';
import DrawQuickDrawLogo from 'assets/img/Draw-QuickDraw-Logo.svg';
import QuickCardLogo from 'assets/img/Quickcard.svg';
import ScratchFastLogo from 'assets/img/Scratchers-Fastplay-Logo.svg';
import constants from 'config/constants';

export interface ITicketField<T> extends IField<T> {}

export type LoginFields = ITicketField<fieldValueTypes>[];

const gameNumberField: ITicketField<string> = {
  type: 'string',
  key: 'gameNumber',
  label: 'Game Number',
  get placeholder(): string {
    return this.label;
  },
  isRequired: true,
  get fieldValue() {
    return this.value;
  }
};

const bookNumberField: ITicketField<string> = {
  type: 'string',
  key: 'bookNumber',
  label: 'Book Number',
  get placeholder(): string {
    return this.label;
  },
  isRequired: true,
  get fieldValue() {
    return this.value;
  }
};

const ticketNumberField: ITicketField<string> = {
  type: 'string',
  key: 'ticketNumber',
  label: 'Ticket Number',
  get placeholder(): string {
    return this.label;
  },
  isRequired: true,
  get fieldValue() {
    return this.value;
  }
};

const validationCodeField: ITicketField<string> = {
  type: 'string',
  key: 'validationCode',
  label: 'VIRN Number',
  get placeholder(): string {
    return this.label;
  },
  isRequired: true,
  get fieldValue() {
    return this.value;
  }
};

const quickCardTab: ITicketTab = {
  tabLogo: QuickCardLogo,
  tabKey: 'quickCard',
  tabTitle: 'ticket.quickCard.tabTitle',
  fields: [
    {
      key: 'Ticket-QuickCard-Entry-Code',
      label: 'ticket.quickCard.entryCodeLabel',
      placeholder: '00000-00000-00000-00000-0000',
      maskKey: 'QuickCardTicketEntryCodeInputMask',
      mask: [
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ],
      min: 24,
      numbersOnly: true
    }
  ],
  sampleImageLink: 'ticket.sampleImageLink',
  sampleImage: constants.SAMPLE_QUICK_CARD_TICKET_KEY,
  eligibleGamesEnabled: true,
  eligibleGameText: 'ticket.eligibleGames',
  eligibleGameLinkText: 'ticket.eligibleGamesLink',
  consentText: 'ticket.consentText'
};

export const getTicketTab = (enableQuickCard: boolean, enableQuickDraw: boolean) =>
  enableQuickCard ? [...getTicketTabs(enableQuickDraw), quickCardTab] : getTicketTabs(enableQuickDraw);

const getTicketTabs = (enableQuickDraw: boolean): ITicketTab[] => [
  {
    tabLogo: ScratchFastLogo,
    tabKey: 'scratchTicket',
    tabTitle: 'ticket.scratch.tabTitle',
    fields: [
      {
        key: 'Ticket-Barcode-Number',
        label: 'ticket.scratch.ticketNumberLabel',
        placeholder: '0000-000000-000',
        maskKey: 'TicketBarcodeInputMask',
        mask: [/[0-9]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
        min: 13,
        numbersOnly: true
      },
      {
        key: 'Validation-Number',
        label: 'ticket.scratch.entryCodeLabel',
        placeholder: '000',
        maskKey: 'TicketValidationInputMask',
        mask: [/[0-9]/, /\d/, /\d/],
        min: 3,
        numbersOnly: true
      }
    ],
    sampleImageLink: 'ticket.sampleImageLink',
    sampleImage: constants.SAMPLE_SCRATCH_TICKET_KEY,
    eligibleGamesEnabled: true,
    eligibleGameText: 'ticket.eligibleGames',
    eligibleGameLinkText: 'ticket.eligibleGamesLink',
    consentText: 'ticket.consentText'
  },
  {
    tabLogo: enableQuickDraw ? DrawQuickDrawLogo : DrawLogo,
    tabKey: 'drawTicket',
    tabTitle: enableQuickDraw ? 'ticket.draw.tabFullTitle' : 'ticket.draw.tabTitle',
    fields: [
      {
        key: 'Ticket-Entry-Code',
        label: 'ticket.draw.entryCodeLabel',
        placeholder: '00000-00000-00000-00000-00000',
        maskKey: 'TicketEntryCodeInputMask',
        mask: [
          /[A-Za-z0-9]/,
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          '-',
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          '-',
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          '-',
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          '-',
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          /\w/
        ],
        min: 25,
        numbersOnly: false
      }
    ],
    sampleImageLink: 'ticket.sampleImageLink',
    sampleImage: enableQuickDraw ? constants.SAMPLE_DRAW_QUICK_DRAW_TICKET_KEY : constants.SAMPLE_DRAW_TICKET_KEY,
    eligibleGamesEnabled: true,
    eligibleGameText: 'ticket.eligibleGames',
    eligibleGameLinkText: 'ticket.eligibleGamesLink',
    consentText: 'ticket.consentText'
  }
  // {
  //   tabKey: 'fastPlayTicket',
  //   tabTitle: 'ticket.fastPlay.tabTitle',
  //   fields: [
  //     {
  //       key: 'Ticket-Barcode-Number',
  //       label: 'ticket.fastPlay.ticketNumberLabel',
  //       placeholder: '0000-000000-000',
  //       maskKey: 'FastPlayBarcodeInputMask',
  //       mask: [/[0-9]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
  //       min: 13,
  //       numbersOnly: true
  //     },
  //     {
  //       key: 'Validation-Number',
  //       label: 'ticket.fastPlay.entryCodeLabel',
  //       placeholder: '000',
  //       maskKey: 'FastPlayValidationInputMask',
  //       mask: [/[0-9]/, /\d/, /\d/],
  //       min: 3,
  //       numbersOnly: true
  //     }
  //   ],
  //   sampleImageLink: 'ticket.sampleImageLink',
  //   sampleImage: constants.SAMPLE_FAST_PLAY_TICKET_KEY,
  //   eligibleGamesEnabled: true,
  //   eligibleGameText: 'ticket.eligibleGames',
  //   eligibleGameLinkText: 'ticket.eligibleGamesLink',
  //   consentText: 'ticket.consentText'
  // }
];

export const getTicketHelpTabs = (activeTabKey: string) => helpTabs.filter(tab => tab.parentTabKey === activeTabKey);

export const helpTabs = [
  {
    tabKey: 'scratchTicket',
    tabTitle: 'ticket.scratch.helpTabTitle',
    sampleImage: require('assets/img/sample-tickets/scratcher-manual-entry.webm'),
    parentTabKey: 'scratchTicket'
  },
  {
    tabKey: 'fastPlayTicket',
    tabTitle: 'ticket.fastPlay.helpTabTitle',
    sampleImage: require('assets/img/sample-tickets/fastplay-manual-entry.webm'),
    parentTabKey: 'scratchTicket'
  },
  {
    tabKey: 'drawTicket',
    tabTitle: 'ticket.draw.helpTabTitle',
    sampleImage: require('assets/img/sample-tickets/drawgame-manual-entry.webm'),
    parentTabKey: 'drawTicket'
  },
  {
    tabKey: 'quickDrawTicket',
    tabTitle: 'ticket.quickDraw.helpTabTitle',
    sampleImage: require('assets/img/sample-tickets/quickdraw-manual-entry.webm'),
    parentTabKey: 'drawTicket'
  }
];

export const ticketFields: LoginFields = [gameNumberField, bookNumberField, ticketNumberField, validationCodeField];
